import { css } from "styled-components";

export const rem = (pxValue) => `${pxValue / 16}rem`;

export const hexToRGBTriplet = (h) => {
  let r = 0,
    g = 0,
    b = 0;

  // 3 digits
  if (h.length === 4) {
    r = "0x" + h[1] + h[1];
    g = "0x" + h[2] + h[2];
    b = "0x" + h[3] + h[3];

    // 6 digits
  } else if (h.length === 7) {
    r = "0x" + h[1] + h[2];
    g = "0x" + h[3] + h[4];
    b = "0x" + h[5] + h[6];
  }

  return `${+r},${+g},${+b}`;
};

export const hexToRGBA = (h, a) => {
  return `rgba(${hexToRGBTriplet(h)},${+a})`;
};

export const contentSpacing = css`
  // Set max width so that the content (not padding) goes all the way to 1140px wide.
  max-width: calc(1140px + 6rem);
  margin-left: auto;
  margin-right: auto;
  padding: 0 1rem;

  ${({ theme }) => theme.media.sm} {
    padding: 0 3rem;
  }

  .exceed-content {
    margin-left: -1.25rem;
    margin-right: -1.25rem;

    ${({ theme }) => theme.media.sm} {
      margin-left: -3rem;
      margin-right: -3rem;
    }
  }
`;
